var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoneyOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 84,
    viewBox: "0 0 75 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.518 18.2C47.8247 18.2 50.9047 22.1667 51.1847 28H61.498C61.1714 19.9733 56.2714 12.6 46.518 10.22V0H32.518V10.08C30.698 10.4533 29.018 11.06 27.3847 11.76L34.4314 18.8067C35.9247 18.4333 37.6514 18.2 39.518 18.2ZM6.71135 4.29333L0.131348 10.8733L16.1847 26.9267C16.1847 36.6333 23.4647 41.9533 34.4314 45.1733L50.8114 61.5533C49.2247 63.84 45.9114 65.8 39.518 65.8C29.9047 65.8 26.1247 61.5067 25.6113 56H15.3447C15.9047 66.22 23.558 71.96 32.518 73.8733V84H46.518V73.9667C50.998 73.1267 55.058 71.4 57.998 68.74L68.358 79.1L74.938 72.52L6.71135 4.29333Z",
    fill: "url(#paint0_linear_1_81)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_81",
    x1: 37.5347,
    y1: 0,
    x2: 37.5347,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0D2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99A27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyOff);
export default __webpack_public_path__ + "static/media/money_off.9f0a0ab76e4b6a1e887e2f4f84a54ecf.svg";
export { ForwardRef as ReactComponent };